import { CheckboxField } from '@monorepo/shared/componentsV2/fields/CheckboxField';
import { getFieldNameWithPrefix } from '@monorepo/shared/componentsV2/fields/fieldUtils';
import {
  FormTemplateFieldTypes,
  supportedDuplicableGroupDisplayFieldTypes,
} from 'mapistry-shared';
import React from 'react';
import { useField } from 'react-final-form';
import { ModalFieldWrapper } from '../../styled';

type EditIsDuplicableDisplayFieldProps = {
  isInDuplicableSection: boolean;
  prefix?: string;
};

function useCanBeDuplicableDisplayField(
  isInDuplicableSection: boolean,
  prefix?: string,
) {
  const {
    input: { value: fieldType },
  } = useField<FormTemplateFieldTypes>(getFieldNameWithPrefix('type', prefix));

  return (
    isInDuplicableSection &&
    supportedDuplicableGroupDisplayFieldTypes.includes(fieldType)
  );
}

export function EditIsDuplicableDisplayField({
  isInDuplicableSection,
  prefix,
}: EditIsDuplicableDisplayFieldProps) {
  const canBeDuplicableDisplayField = useCanBeDuplicableDisplayField(
    isInDuplicableSection,
    prefix,
  );
  if (!canBeDuplicableDisplayField) {
    return null;
  }

  return (
    <ModalFieldWrapper>
      <CheckboxField
        name={getFieldNameWithPrefix('isDuplicableDisplayField', prefix)}
        label="Subsection Title Field"
        helperText="If checked, this field will be shown as the subsection title when the form is filled out."
      />
    </ModalFieldWrapper>
  );
}
